<template>
    <div style="width: 100%; height: 100%; margin: 0; padding: 20px; overflow-y: auto; text-align: left; box-sizing: border-box;">
        <side-menu-header :role="store.state.user.role"></side-menu-header>
        <div class="headers">
            <h1>Finance</h1>
        </div>

        <div class="finance__section" style="height: 50px; margin-top: 50px;">
            <div class="balance-display" style="float: left; border: 1px solid rgb(46, 163, 255); border-radius: 5px; padding: 5px 12px; font-size: 24px; line-height: 29px; color: rgb(0, 0, 0); margin-top: 4px; height: 24px; padding-bottom: 8px;">
                Balance: <b>${{amount}}</b>
            </div>
            <div class="stripe__connection" v-if="user.stripe === null">
              <a :href="url" class="stripe-redirect-button" @click="redirect">
                <span>
                  Connect with Stripe
                </span>
              </a>
            </div>
        </div>

        <div class="driver__finance">
            <div class="list__header" style="display: flex; margin-top: 15px; maring-bottom: 5px; margin-bottom: 5px; padding: 10px 0 10px 15px;">
                <p class="campaign__header" style="width: 44%;">TRANSACTION</p>
                <p class="advertiser__header" style="width: 37%;">AMOUNT</p>
                <p class="campaignid__header" style="width: 19%; text-align: center;">DATE</p>
            </div>
            <div class="list" style="color: black;" v-for="transaction in transactions" v-bind:key="transaction.created">
                <div class="finance__item" style="display: flex; padding: 0px 0 5px 15px; background: #EBEAF4; opacity: 0.48; border-radius: 0.5em;"  v-if="transaction.successful == 'Yes'">
                    <div style="width: 44%;">
                        <p>{{transaction.type}}</p>
                    </div>
                    <div style="width: 37%;">
                        <p>$ {{transaction.amount}}</p>
                    </div>
                    <div style="width: 19%; text-align: center;">
                        <p>{{dataFormat(transaction.created)}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideMenuHeader from './../design/SideMenuHeader.vue'
import store from '@store/index.js'
import Config from '@utils/Config.js'
import { mapGetters } from 'vuex'
import toast from '@utils/toast.js'
export default {
    name: 'DriverFinance',
    data: function () {
        return {
            url: '',
            transactions: [],
            transactionID: 'Transaction ID',
            counter: 0,
            amount: 0,
            store: store
        }
    },
    components: {
      SideMenuHeader
    },
    methods: {
        getPayments () {
            var url = '/get/payments'

            this.request(url, 'POST', {}).then((response) => {
                if (response.code === 0) {
                    toast.successMessage('Got payments')
                    this.transactions = response.data
                    this.calculateAmount()
                } else {
                    toast.errorMessage(response.message)
                    if (response.code === 112) {
                        //bad token
                    }
                }
            }).catch((error) => {
            })
        },
        setStripURL () {
            this.url = 'https://connect.stripe.com/express/oauth/authorize?redirect_uri=https://stripe.adwayusa.com/stripe_driver_callback.php&client_id=ca_DvruLcfcJ4B2VVGncRn0TWNfPFHvJBs8&state=WEB' + this.token.token + this.user.user
            this.url = this.setExtraParameters(this.url)
        },
        calculateAmount () {
            if (this.transactions.length > 0) {
                this.transactions.forEach((transaction) => {
                    if (transaction.successful === 'Yes') {
                        this.amount += transaction.amount
                    }
                })
            }
        },
        setExtraParameters (url) {
            if (this.user.user !== null || this.user.user !== "") {
                url += '&stripe_user[email]=' + this.user.user
            }

            if (this.user.phone !== null || this.user.phone !== "") {
                url += '&stripe_user[phone_number]=' + this.user.phone
            }

            if (this.user.company !== null || this.user.company !== "") {
                url += '&stripe_user[business_name]=' + this.user.company
            }

            if (this.user.firstname !== null || this.user.firstname !== "") {
                url += '&stripe_user[first_name]=' + this.user.firstname
            }

            if (this.user.surname !== null || this.user.surname !== "") {
                url += '&stripe_user[last_name]=' + this.user.surname
            }

            return url
        },
        redirect () {
            var token = this.token
            token.redirect = true
            this.store.commit('setToken', token)
        },
        dataFormat (fullName) {
            var dataSplit = fullName.split(' ')
            var date = dataSplit[0]
            var time = dataSplit[1]
            var dateSplit = date.split('-')
            var timeSplit = time.split(':')
            return this.makedate(dateSplit) + ' ' + this.makeTime(timeSplit)
        },
        makedate (dateArray) {
            var months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.']
            var string = ''
            string += months[parseInt(dateArray[1]) - 1]
            string += ' ' + dateArray[2] + ', ' + dateArray[0]
            return string
        },
        makeTime (timeArray) {
            var morning = true
            var hours = parseInt(timeArray[0])
            if (hours > 12) {
                morning = false
                hours -= 12
            }
            var string = `${hours > 9 ? '' + hours : '0' + hours}:${timeArray[1]}  ${morning ? 'AM' : 'PM'} `
            return string
        },
        checkTokenConditions () {
            try{
                var expiresDate = new Date(this.token.expires)
            } catch (err) {
                this.$router.push('/login')
            }
            var now = new Date()
            if (expiresDate <= now) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            } else {
                var body = {
                code: '',
                    refresh_token: this.token.refresh_token
                }
                this.request('/refresh/token', 'POST', body).then((response) => {
                    if (response.code === 0 ) {
                        store.commit('setToken', response.data[0])
                        store.commit('setDriver', response.data[0].driver)
                        this.getProfile()
                    } else if (response.code === 112) {
                        this.store.commit('setToken', {})
                        this.$router.push('/login')
                    }
                }).catch((error) => {
                })
            }
            var token = this.token
            token.redirect = false
            this.store.commit('setToken', token)
        },
        getProfile () {
            this.request('/get/profile', 'POST', {}).then((response) => {
                if (response.code === 0) {
                    store.commit('setUser', response.data[0])
                    this.calculateAmount()
                    if (response.data[0].stripe) {
                        this.initStripeScript()
                    }
                } else {
                    toast.errorMessage(response.message)
                    if (response.code === 112) {
                        // token invalid
                    }
                }
            }).catch((error) => {
                toast.errorMessage(error)
            })
        }
    },
    created: function () {
        if (this.token && this.token.redirect) {
            this.checkTokenConditions()
        } else {
            this.getPayments()
            this.setStripURL()
        }
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
            token: 'getToken',
        })
    }
}
</script>

<style scoped>

.stripe-redirect-button{
  display: inline-block;
  margin-bottom: 1px;
  background-image: -webkit-gradient(linear,left top,left bottom,from(#28a0e5),to(#015e94));
  background-image: linear-gradient(#28a0e5,#015e94);
  -webkit-font-smoothing: antialiased;
  border: 0;
  padding: 1px;
  height: 32px;
  text-decoration: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 0 rgba(0,0,0,.2);
  box-shadow: 0 1px 0 rgba(0,0,0,.2);
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none !important;
}

.stripe-redirect-button span {
  display: block;
  position: relative;
  padding: 0 12px;
      padding-left: 12px;
  height: 36px;
  background: #1275ff;
      background-image: none;
  background-image: -webkit-gradient(linear,left top,left bottom,from(#7dc5ee),color-stop(85%,#008cdd),to(#30a2e4));
  background-image: linear-gradient(#7dc5ee,#008cdd 85%,#30a2e4);
  font-size: 15px;
  line-height: 38px;
  color: #fff;
  font-weight: 700;
  font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
  text-shadow: 0 -1px 0 rgba(0,0,0,.2);
  -webkit-box-shadow: inset 0 1px 0 hsla(0,0%,100%,.25);
  box-shadow: inset 0 1px 0 hsla(0,0%,100%,.25);
  border-radius: 3px;
  padding-left: 44px;
  width: 142px;
}

.stripe-redirect-button span::before {
  background-image: url("./../../assets/stripe_sign.png");
  content: "";
  display: block;
  position: absolute;
  left: 11px;
  top: 50%;
  width: 23px;
  height: 24px;
  margin-top: -12px;
  background-repeat: no-repeat;
  background-size: 23px 24px;
}

</style>
